"use strict";
// (C) 2020-2022 GoodData Corporation
Object.defineProperty(exports, "__esModule", { value: true });
exports.filterDrillFromAttributeByPriority = exports.getTotalDrillToUrlCount = exports.getDrillDownAttributeTitle = void 0;
var tslib_1 = require("tslib");
var sdk_model_1 = require("@gooddata/sdk-model");
var sdk_ui_1 = require("@gooddata/sdk-ui");
var isEqual_1 = tslib_1.__importDefault(require("lodash/isEqual"));
var compact_1 = tslib_1.__importDefault(require("lodash/compact"));
var uniqWith_1 = tslib_1.__importDefault(require("lodash/uniqWith"));
var drillingUtils_1 = require("../../../_staging/drills/drillingUtils");
var types_1 = require("../types");
/**
 * @internal
 */
function getDrillDownAttributeTitle(localIdentifier, drillEvent) {
    return (drillEvent.drillContext.intersection || [])
        .map(function (intersectionElement) { return intersectionElement.header; })
        .filter(sdk_ui_1.isDrillIntersectionAttributeItem)
        .filter(function (intersectionAttributeItem) {
        return intersectionAttributeItem.attributeHeader.localIdentifier === localIdentifier;
    })
        .map(function (intersectionAttributeItem) { return intersectionAttributeItem.attributeHeaderItem.name; })[0];
}
exports.getDrillDownAttributeTitle = getDrillDownAttributeTitle;
/**
 * Get total number of IDrillToUrl
 * @internal
 */
function getTotalDrillToUrlCount(drillDefinition) {
    return drillDefinition.filter(types_1.isDrillToUrl).length;
}
exports.getTotalDrillToUrlCount = getTotalDrillToUrlCount;
/**
 * Implicit drill (currently IDrillDownDefinition and implicit IDrillToAttributeUrl) has lower priority,
 * so needs to be removed when other drill config exists for the same attribute
 *
 * @internal
 */
function filterDrillFromAttributeByPriority(drillDefinitions, configuredDrills) {
    if (configuredDrills === void 0) { configuredDrills = []; }
    // need create deep equal unique drills array because we can get same two drills that are configured and implicit e.g. IDrillToAttributeUrl
    // and is not able to configure more drills on one origin
    // configured once has higher priority
    var uniqueDrillDefinitions = uniqWith_1.default(drillDefinitions, isEqual_1.default);
    var drillOriginsWithoutImplicitDrills = compact_1.default(uniqueDrillDefinitions.map(function (drill) {
        if (!sdk_model_1.isDrillToLegacyDashboard(drill) && drillingUtils_1.isDrillConfigured(drill, configuredDrills)) {
            return drillingUtils_1.getDrillOriginLocalIdentifier(drill);
        }
    }));
    return uniqueDrillDefinitions.filter(function (drill) {
        if (sdk_model_1.isDrillToLegacyDashboard(drill)) {
            return true;
        }
        if (!drillingUtils_1.isDrillConfigured(drill, configuredDrills)) {
            return !drillOriginsWithoutImplicitDrills.includes(drillingUtils_1.getDrillOriginLocalIdentifier(drill));
        }
        return true;
    });
}
exports.filterDrillFromAttributeByPriority = filterDrillFromAttributeByPriority;
//# sourceMappingURL=drillDownUtils.js.map